import React from "react";
import ThemeSelector from "./dashboard/settings/branding/ThemeSelector";
import InputColor from "./dashboard/settings/branding/InputColor";
import MultiOptionsInput from "./dashboard/settings/branding/MultiOptionsInput";
import ImageSelector from "./dashboard/settings/branding/ImageSelector";
import LogoOverlayComponent from "./dashboard/settings/LogoOverlayComponent";

import LoginWrapper from "./LoginWrapper";
import OnboardingHeader from "./onboarding/OnboardingHeader";
import DailyDashboardPreview from "./dashboard/settings/DailyDashboardPreview";
import { setAppliedMode } from "../utils/theme-helpers";
import WebAppPreview from "./onboarding/WebAppPreview";
import { GradientRange } from "../parts/inputs/GradientRange";

const INITIAL_STATE_DATA = {
  stage: "branding",
  //   Testing step to render exerciseInfo on refresh
  //   step: "primaryColor",
  step: "brandingInfo",
  colorChanged: false,
  themeChanged: false,
  logoImg: {},
  formLogoImg: {},
  mobileSplashImg: {},
  formMobileSplashImg: "",
  mobileSplashBg: {},
  formMobileSplashBg: "",
  isSplashImgTinted: false,
  appMainColor: "#5bc500",
  appSecondaryTextColor: "black",
  appTheme: "dark",
  webAppTheme: "dark",
  whiteBg: false,
  splashOverlay: true,
  splashOverlayColor: "#000000",
  splashOverlayOpacity: 50,
  viewportWidth: null,
};

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE_DATA;
    this.nextStep = this.nextStep.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.handleReturnButton = this.handleReturnButton.bind(this);
  }

  updateDimensions() {
    this.setState((prevState) => ({
      ...prevState,
      viewportWidth: window.innerWidth,
    }));
  }

  componentDidMount() {
    !this.state.viewportWidth &&
      this.setState((prevState) => ({
        ...prevState,
        viewportWidth: window.innerWidth,
      }));
    window.addEventListener("resize", this.updateDimensions);

    (function (w) {
      w.fpr =
        w.fpr ||
        function () {
          w.fpr.q = w.fpr.q || [];
          w.fpr.q[arguments[0] == "set" ? "unshift" : "push"](arguments);
        };
    })(window);
    fpr("init", { cid: "9g2bue8j" });
    fpr("click");
    const script = document.createElement("script");
    script.src = "https://cdn.firstpromoter.com/fpr.js";
    script.async = true;
    document.head.appendChild(script);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  nextStep(e) {
    e.preventDefault();
    switch (this.state.step) {
      case "brandingInfo":
        return this.setState((prevState) => ({
          ...prevState,
          step: "appTheme",
        }));
      case "appTheme":
        return this.setState((prevState) => ({
          ...prevState,
          step: "primaryColor",
        }));
      case "primaryColor":
        return this.setState((prevState) => ({
          ...prevState,
          step: "appLogo",
        }));
      case "appLogo":
        return this.setState((prevState) => ({
          ...prevState,
          step: "appIcon",
        }));
      case "appIcon":
        return this.setState((prevState) => ({
          ...prevState,
          step: "exerciseInfo",
          stage: "exercise",
        }));
      default:
        break;
    }
  }

  handleReturnButton(e) {
    e?.preventDefault?.();
    switch (this.state.step) {
      case "brandingInfo":
        return;
      case "appTheme":
        return this.setState((prevState) => ({
          ...prevState,
          step: "brandingInfo",
        }));
      case "primaryColor":
        return this.setState((prevState) => ({
          ...prevState,
          step: "appTheme",
        }));
      case "appLogo":
        return this.setState((prevState) => ({
          ...prevState,
          step: "primaryColor",
        }));
      case "appIcon":
        return this.setState((prevState) => ({
          ...prevState,
          step: "appLogo",
        }));
      case "exerciseInfo":
        return this.setState((prevState) => ({
          ...prevState,
          step: "appIcon",
          stage: "branding",
        }));
      default:
        break;
    }
  }

  handleChange(event) {
    const target = event.target || event;
    const { whiteBg, splashOverlay, isSplashImgTinted } = this.state;
    if (target.name === "whiteLogoBackground") {
      this.setState({ whiteBg: !whiteBg });
      return;
    }
    if (target.name === "tintSplashImg") {
      this.setState({ isSplashImgTinted: !isSplashImgTinted });
      return;
    }
    if (target.name === "appMainColorPicker") {
      this.setState({ appMainColor: target.value });
      return;
    }
    if (target.name === "customBranding[logoImg]") {
      this.setState({ logoChanged: true, imageChanged: true });
    }
    if (target.name === "customBranding[mobileSplashImg]") {
      this.setState({
        mobileSplashChanged: true,
        temporalSplashImg: event.backgroundImage,
        imageChanged: true,
      });
    }
    if (target.name === "customBranding[mobileSplashBg]") {
      this.setState({
        mobileSplashBgChanged: true,
        temporalSplashBg: event.backgroundImage,
        imageChanged: true,
      });
    }
    if (target.name === "splashOverlay") {
      this.setState({ splashOverlay: !splashOverlay });
      return;
    }
    if (target.name === "splashOverlayColorPicker") {
      this.setState({ splashOverlayColor: target.value });
      return;
    }
    this.setState({ [target.name]: target.value });
  }

  render() {
    const {
      stage,
      step,
      whiteBg,
      appMainColor,
      isSplashImgTinted,
      logoImg,
      formLogoImg,
      mobileSplashImg,
      formMobileSplashImg,
      mobileSplashChanged,
      mobileSplashBg,
      formMobileSplashBg,
      mobileSplashBgChanged,
      splashOverlay,
      splashOverlayColor,
      splashOverlayOpacity,
      logoChanged,
      appTheme,
      appSecondaryTextColor,
      temporalSplashBg,
      temporalSplashImg,
      webAppTheme,
    } = this.state;

    return (
      <LoginWrapper
        mainClass="Onboarding branding"
        left={
          <form
            id="form-branding"
            method="POST"
            encType="multipart/form-data"
            data-noreset
          >
            <OnboardingHeader
              onBack={this.handleReturnButton}
              active={stage === "branding" ? 3 : 4}
              phrase={stage === "branding" ? "Branding" : "Exercise"}
              title={stage === "branding" ? "Branding" : "Exercise Library"}
              noBack={this.state.step === "brandingInfo"}
            />

            <div className="mobile-branding-placeholder only-show-mobile">
              <div
                className={`app-icons-image ${step !== "appIcon" && "hidden"}`}
              >
                <img
                  src="/img/mobile-icons-group.webp"
                  style={{ height: "100%" }}
                />
              </div>

              <div
                className={`branding-examples-image ${
                  step !== "brandingInfo" && "hidden"
                }`}
              >
                <img
                  src="/img/branding-image.webp"
                  style={{ height: "100%" }}
                />
              </div>

              <div
                className={`exercise-phone-image only-show-mobile ${
                  ![
                    "appTheme",
                    "primaryColor",
                    "appLogo",
                    "exerciseInfo",
                  ].includes(step) && "hidden"
                }`}
              >
                {["appTheme", "primaryColor"].includes(step) ? (
                  <>
                    {step === "appTheme" ? (
                      <div className={`section phone-template web ${step}`}>
                        <div
                          className="background-container"
                          style={{ left: "10%", top: "8%" }}
                        >
                          <WebAppPreview />
                        </div>
                        <img alt="phone" src="/img/macbook-template.webp" />
                      </div>
                    ) : null}
                    <div className={`section phone-template mobile ${step}`}>
                      <div className="background-container">
                        <DailyDashboardPreview
                          theme={appTheme}
                          brandingColor={appMainColor}
                          isDefaultColor={false}
                          secondaryTextColor={appSecondaryTextColor}
                        />
                      </div>
                      <img alt="phone" src="/img/iphone-template.webp" />
                    </div>
                  </>
                ) : null}
                {["appLogo", "exerciseInfo"].includes(step) ? (
                  <div className={`section phone-template mobile ${step}`}>
                    <div
                      className="background-container"
                      style={{
                        backgroundImage: temporalSplashBg
                          ? `url(${temporalSplashBg})`
                          : "var(--black)",
                        backgroundColor: "var(--black)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <LogoOverlayComponent
                        opacity={splashOverlayOpacity}
                        overlayColor={splashOverlayColor}
                        withOverlay={splashOverlay && mobileSplashBgChanged}
                        withLogo
                        logo={mobileSplashImg}
                        isTinted={isSplashImgTinted}
                        splashLogoSrc={temporalSplashImg}
                      />
                    </div>
                    <img alt="phone" src="/img/iphone-template.webp" />
                  </div>
                ) : null}
              </div>
            </div>

            <div>
              <div
                className={`branding-info ${
                  step !== "brandingInfo" && "hidden"
                }`}
              >
                <h4 className="clipped w-fit">BRANDING</h4>
                <h1 className="!text-[--white] mt-2 !text-5xl">
                  Lets Design Your App
                </h1>
                <p className="mt-4">
                  MyStrengthBook provides you the freedom to create a custom
                  branded mobile application without having to code. Look more
                  professional by having your own mobile app. Let's get to it!
                </p>
              </div>

              <div
                className={`app-theme-wrapper ${
                  step !== "appTheme" && "hidden"
                }`}
              >
                <h2 className="mobile-hidden">App Theme</h2>
                <div className="apptheme-placeholder">
                  <ThemeSelector
                    inputName="appTheme"
                    value={appTheme}
                    onChange={(name, value) => {
                      this.setState({
                        [name]: value,
                        themeChanged: true,
                      });
                    }}
                    boxSmall
                    selectedBorder
                    label="Mobile App Theme"
                  />
                  <ThemeSelector
                    inputName="webAppTheme"
                    value={webAppTheme}
                    onChange={(name, value) => {
                      this.context.locals.theme = value;
                      setAppliedMode(value);
                      this.setState({
                        [name]: value,
                        themeChanged: true,
                      });
                    }}
                    boxSmall
                    selectedBorder
                    label="Web App Theme"
                    isStorefront
                  />
                </div>
              </div>
              <div
                className={`primary-color-wrapper ${
                  step !== "primaryColor" && "hidden"
                }`}
              >
                <div>
                  <h3>Lets Select The Primary Color</h3>

                  <InputColor
                    mobile={this.state.viewportWidth <= 960}
                    inputName="appMainColor"
                    inputNameColor="appMainColorPicker"
                    value={appMainColor}
                    onChange={(evt) => {
                      this.setState({
                        colorChanged: true,
                      });
                      this.handleChange(evt);
                    }}
                  />
                </div>
                <div className="mt-16">
                  <h3>
                    Secondary Color <span>(Text Color)</span>
                  </h3>

                  <MultiOptionsInput
                    value={appSecondaryTextColor}
                    inputName="appSecondaryTextColor"
                    onChange={(name, value) => {
                      this.setState({
                        colorChanged: true,
                      });
                      this.handleChange({
                        target: {
                          name,
                          value,
                        },
                      });
                    }}
                    options={["white", "black"]}
                  />
                </div>
              </div>

              <div
                className={`app-logo-wrapper ${step !== "appLogo" && "hidden"}`}
              >
                <div className="applogo-placeholder">
                  <ImageSelector
                    mobile={this.state.viewportWidth <= 960}
                    title="In-App Logo"
                    selectorTitle="Upload Logo"
                    subInfo="JPG, GIF SVG Or PNG. Max Size: 800KB"
                    toolTipTextBody={
                      "This is the logo that appears inside your mobile app"
                    }
                    forOnboarding
                    additionalContent={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        className="switch-container"
                      >
                        <input
                          name="whiteLogoBackground"
                          value={whiteBg}
                          hidden
                        />
                        <span>White Logo Background</span>
                        <img
                          className="toggle-button"
                          src={`/img/new-icons/toggle${
                            whiteBg ? "_on" : "_off"
                          }.svg`}
                          alt="unpublish"
                          onClick={() => {
                            this.handleChange({
                              target: {
                                name: "whiteBg",
                                value: !whiteBg,
                              },
                            });
                          }}
                          style={{ position: "relative" }}
                        />
                      </div>
                    }
                    additionalStyle={
                      this.state.viewportWidth <= 960
                        ? {
                            width: "fit-content",
                          }
                        : {
                            marginTop: 16,
                            marginBottom: 16,
                            backgroundColor: whiteBg ? "#fff" : null,
                          }
                    }
                    {...(this.state.viewportWidth <= 960 && {
                      imageDimensions: { marginTop: 0 },
                    })}
                    value={logoImg}
                    onChange={this.handleChange}
                    inputName="customBranding[logoImg]"
                    id="logoImg"
                    imageInputs={[
                      { name: "logoChanged", value: logoChanged },
                      {
                        name: "formLogoImgFile",
                        value: formLogoImg.file || "",
                      },
                      {
                        name: "formLogoImgType",
                        value: formLogoImg.type || "",
                      },
                      {
                        name: "formLogoImgName",
                        value: formLogoImg.name || "",
                      },
                      {
                        name: "formLogoImgS3Path",
                        value: formLogoImg.s3Path,
                      },
                    ]}
                    showButton={false}
                    blackBg
                  />
                  <ImageSelector
                    mobile={this.state.viewportWidth <= 960}
                    title="Splash Screen Logo"
                    selectorTitle="Upload Logo"
                    subInfo="JPG, GIF SVG Or PNG. Max Size: 800KB"
                    toolTipTextBody={
                      "This is the logo that appears over the splash screen image when you launch the app"
                    }
                    forOnboarding
                    value={mobileSplashImg}
                    onChange={this.handleChange}
                    additionalStyle={
                      this.state.viewportWidth <= 960
                        ? {
                            width: "fit-content",
                          }
                        : {
                            marginTop: 16,
                            marginBottom: 16,
                          }
                    }
                    {...(this.state.viewportWidth <= 960 && {
                      imageDimensions: { marginTop: 0 },
                    })}
                    additionalContent={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          margin: 0,
                        }}
                        className="switch-container"
                      >
                        <input
                          name="tintSplashImg"
                          value={isSplashImgTinted}
                          hidden
                        />
                        <span>Tint Splashscreen Logo</span>
                        <img
                          className="toggle-button"
                          src={`/img/new-icons/toggle${
                            isSplashImgTinted ? "_on" : "_off"
                          }.svg`}
                          alt="unpublish"
                          onClick={() => {
                            this.handleChange({
                              target: {
                                name: "tintSplashImg",
                                value: !isSplashImgTinted,
                              },
                            });
                          }}
                          style={{ position: "relative" }}
                        />
                      </div>
                    }
                    inputName="customBranding[mobileSplashImg]"
                    id="mobileSplashImg"
                    imageInputs={[
                      {
                        name: "mobileSplashChanged",
                        value: mobileSplashChanged,
                      },
                      {
                        name: "formMobileSplashImgFile",
                        value: formMobileSplashImg.file || "",
                      },
                      {
                        name: "formMobileSplashImgType",
                        value: formMobileSplashImg.type || "",
                      },
                      {
                        name: "formMobileSplashImgName",
                        value: formMobileSplashImg.name || "",
                      },
                      {
                        name: "formMobileSplashImgS3Path",
                        value: formMobileSplashImg.s3Path,
                      },
                    ]}
                    showButton={false}
                    blackBg
                  />
                  <ImageSelector
                    mobile={this.state.viewportWidth <= 960}
                    title="Background Image"
                    selectorTitle="Upload Image"
                    subInfo="JPG, GIF SVG Or PNG. Max Size: 800KB"
                    toolTipTextBody={
                      "This is the image in the background of the launch screen. Compress the file down to >200kb to ensure it loads fast enough to display"
                    }
                    forOnboarding
                    value={mobileSplashBg}
                    onChange={this.handleChange}
                    additionalContent={
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          rowGap: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: !splashOverlay ? 14 : 0,
                          }}
                          className="switch-container"
                        >
                          <input
                            name="splashOverlay"
                            value={splashOverlay}
                            hidden
                          />
                          <span>Overlay</span>
                          <img
                            className="toggle-button"
                            src={`/img/new-icons/toggle${
                              splashOverlay ? "_on" : "_off"
                            }.svg`}
                            alt="unpublish"
                            onClick={() => {
                              this.handleChange({
                                target: {
                                  name: "splashOverlay",
                                  value: !splashOverlay,
                                },
                              });
                            }}
                            style={{ position: "relative" }}
                          />
                        </div>
                        {splashOverlay ? (
                          <>
                            <InputColor
                              mobile={this.state.viewportWidth <= 960}
                              inputName="splashOverlayColor"
                              inputNameColor="splashOverlayColorPicker"
                              value={splashOverlayColor}
                              onChange={this.handleChange}
                            />
                            <div>
                              <div className="flex justify-between items-center my-2">
                                <span>Opacity</span>
                                <span>{splashOverlayOpacity}</span>
                              </div>

                              <GradientRange
                                onChange={({ target: { value } }) => {
                                  this.setState({
                                    splashOverlayOpacity: parseInt(value),
                                  });
                                }}
                                rangeName={"splashOverlayOpacity"}
                                rangeValue={splashOverlayOpacity}
                              />
                            </div>
                          </>
                        ) : null}
                      </div>
                    }
                    additionalStyle={
                      this.state.viewportWidth <= 960
                        ? {
                            width: "fit-content",
                          }
                        : {
                            marginTop: 16,
                            marginBottom: 16,
                          }
                    }
                    {...(this.state.viewportWidth <= 960 && {
                      imageDimensions: { marginTop: 0 },
                    })}
                    inputName="customBranding[mobileSplashBg]"
                    id="mobileSplashBg"
                    imageInputs={[
                      {
                        name: "mobileSplashBgChanged",
                        value: mobileSplashBgChanged,
                      },
                      {
                        name: "formMobileSplashBgFile",
                        value: formMobileSplashBg.file || "",
                      },
                      {
                        name: "formMobileSplashBgType",
                        value: formMobileSplashBg.type || "",
                      },
                      {
                        name: "formMobileSplashBgName",
                        value: formMobileSplashBg.name || "",
                      },
                      {
                        name: "formMobileSplashBgS3Path",
                        value: formMobileSplashBg.s3Path,
                      },
                    ]}
                    showButton={false}
                    blackBg
                  />
                </div>
              </div>

              <div
                className={`branding-info ${step !== "appIcon" && "hidden"}`}
              >
                <h4 className="clipped w-fit">APP ICON</h4>
                <h1 className="!text-[--white] mt-2 !text-5xl">
                  Add A Custom App Icon
                </h1>
                <p className={`mt-4 ${this.state.step}`}>
                  To add a custom app icon to your app, upgrade your account and
                  add at least 10 athletes. From there you can request the
                  custom app icon from the branding page under settings.
                  <br />
                  <br />
                  MyStrengthBook will reach out to collect your logo and create
                  all the proper formats for the AppStore and Google Play.
                </p>
              </div>

              <div
                className={`branding-info ${
                  step !== "exerciseInfo" && "hidden"
                }`}
              >
                <h4 className="clipped w-fit">CUSTOMIZED</h4>
                <h1 className="!text-[--white] mt-2 !text-5xl">
                  Exercise Library
                </h1>
                <p className={`mt-4 ${this.state.step}`}>
                  Your master exercise library is 100% customized. We do not
                  force you to use our exercise names, demo videos, or overwhelm
                  you with thousands of pre-made exercises. <br />
                  <br />
                  To get you up and running quickly, let's add some commonly
                  used exercises that you prescribe to start building out your
                  master exercise library. You can add your own demo videos
                  later by editing the exercise inside your library.
                </p>
              </div>
            </div>

            <footer>
              {!["submit", "exerciseInfo"].includes(step) ? (
                <button
                  data-button-type="primary"
                  onClick={(e) => this.nextStep(e)}
                  type="button"
                >
                  Continue
                </button>
              ) : (
                <button data-button-type="primary" type="submit">
                  Continue
                </button>
              )}

              <button
                data-button-type="text-white"
                className={
                  step !== "appLogo" || this.state.viewportWidth <= 960
                    ? "hidden"
                    : "!w-auto"
                }
                onClick={(e) => this.nextStep(e)}
              >
                Skip
              </button>
            </footer>
          </form>
        }
        right={
          this.state.viewportWidth && this.state.viewportWidth > 960 ? (
            <>
              <div
                className={`app-icons-image ${step !== "appIcon" && "hidden"}`}
              >
                <img src="/img/icons-group.webp" />
              </div>

              <div
                className={`branding-examples-image ${
                  step !== "brandingInfo" && "!hidden"
                }`}
              >
                <img src="/img/branding-image.webp" className="max-w-[80%]" />
              </div>
              <div
                className={`exercise-phone-image mobile-hidden ${
                  ![
                    "appTheme",
                    "primaryColor",
                    "appLogo",
                    "exerciseInfo",
                  ].includes(step) && "hidden"
                }`}
              >
                {["appTheme", "primaryColor"].includes(step) ? (
                  <>
                    {step === "appTheme" ? (
                      <div
                        className="section phone-template"
                        style={{
                          position: "absolute",
                          width: "auto",
                          top: "-20%",
                          right: "-65%",
                          left: "15%",
                        }}
                      >
                        <div
                          className="background-container"
                          style={{ left: "10%", top: "8%" }}
                        >
                          <WebAppPreview />
                        </div>
                        <img alt="phone" src="/img/macbook-template.webp" />
                      </div>
                    ) : null}
                    <div
                      className="section phone-template"
                      style={
                        step === "appTheme" ? { left: "-22%", top: "20%" } : {}
                      }
                    >
                      <div className="background-container">
                        <DailyDashboardPreview
                          theme={appTheme}
                          brandingColor={appMainColor}
                          isDefaultColor={false}
                          secondaryTextColor={appSecondaryTextColor}
                        />
                      </div>
                      <img alt="phone" src="/img/iphone-template.webp" />
                    </div>
                  </>
                ) : null}
                {["appLogo", "exerciseInfo"].includes(step) ? (
                  <div className="section phone-template">
                    <div
                      className="background-container"
                      style={{
                        backgroundImage: temporalSplashBg
                          ? `url(${temporalSplashBg})`
                          : "var(--black)",
                        backgroundColor: "var(--black)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <LogoOverlayComponent
                        opacity={splashOverlayOpacity}
                        overlayColor={splashOverlayColor}
                        withOverlay={splashOverlay && mobileSplashBgChanged}
                        withLogo
                        logo={mobileSplashImg}
                        isTinted={isSplashImgTinted}
                        splashLogoSrc={temporalSplashImg}
                      />
                    </div>
                    <img alt="phone" src="/img/iphone-template.webp" />
                  </div>
                ) : null}
              </div>
            </>
          ) : null
        }
      />
    );
  }
}

const OnboardingBranding = (app) => {
  app.get("/onboarding-branding", ({ res, isLoggedIn, flash }) => {
    if (!isLoggedIn()) {
      flash("error", "Please login first");
      return res.redirect("/login");
    }
    return (res.body = <View />);
  });

  app.post("/onboarding-branding", async ({ req, locals, res, api, flash }) => {
    const { body, files } = req;
    delete body.appMainColorPicker;
    delete body.splashOverlayColorPicker;
    delete body.splashOverlay;

    const newBody = {};

    body.appColorsDefault = false;

    if (!body.logoChanged) {
      body.logoImg = {
        file: body.formLogoImgFile,
        type: body.formLogoImgType,
        name: body.formLogoImgName,
        s3Path: body.formLogoImgS3Path,
      };
    }
    delete body.formLogoImgFile;
    delete body.formLogoImgType;
    delete body.formLogoImgName;
    delete body.formLogoImgS3Path;
    delete body.logoChanged;

    if (!body.mobileSplashChanged) {
      body.mobileSplashImg = {
        file: body.formMobileSplashImgFile,
        type: body.formMobileSplashImgType,
        name: body.formMobileSplashImgName,
        s3Path: body.formMobileSplashImgS3Path,
      };
    }

    delete body.formMobileSplashImgFile;
    delete body.formMobileSplashImgType;
    delete body.formMobileSplashImgName;
    delete body.formMobileSplashImgS3Path;
    delete body.mobileSplashChanged;

    if (!body.mobileSplashBgChanged) {
      body.mobileSplashBg = {
        file: body.formMobileSplashBgFile,
        type: body.formMobileSplashBgType,
        name: body.formMobileSplashBgName,
        s3Path: body.formMobileSplashBgS3Path,
      };
    }

    delete body.formMobileSplashBgFile;
    delete body.formMobileSplashBgType;
    delete body.formMobileSplashBgName;
    delete body.formMobileSplashBgS3Path;
    delete body.mobileSplashBgChanged;
    delete body.webAppTheme;

    newBody.customBranding = { ...body };

    try {
      await api(`user/${locals.activeUser._id}`, {
        method: "PUT",
        body: newBody,
        files,
      });
      fpr("referral", { uid: locals.activeUser._id, email: locals.activeUser.email });
    } catch (e) {
      flash("error", e.message);
    }

    res.redirect("/onboarding-exercise-library");
  });
};

export default OnboardingBranding;
